module.exports = "/remote-dist/1ae9228b2d438f734580d2e21aa28802.png";